import { SectionTitleContainer } from './style'

function SectionTitle({ className = '', children }) {
  return (
    <SectionTitleContainer className={className}>
      {children}
    </SectionTitleContainer>
  )
}

export default SectionTitle
